/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_TeamsInputs */

const en_pricing_feature_teams = /** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Management`)
};

const es_pricing_feature_teams = /** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de Equipos`)
};

const fr_pricing_feature_teams = /** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion d'équipe`)
};

const de_pricing_feature_teams = /** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team-Management`)
};

const id_pricing_feature_teams = /** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manajemen Tim`)
};

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const ja_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const zh_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const ar_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const it_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const ru_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const pt_pricing_feature_teams = en_pricing_feature_teams;

/** @type {(inputs: Pricing_Feature_TeamsInputs) => LocalizedString} */
const ko_pricing_feature_teams = en_pricing_feature_teams;

/**
* | output |
* | --- |
* | "Team Management" |
*
* @param {Pricing_Feature_TeamsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_teams = /** @type {((inputs?: Pricing_Feature_TeamsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_TeamsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_teams(inputs)
	if (locale === "es") return es_pricing_feature_teams(inputs)
	if (locale === "fr") return fr_pricing_feature_teams(inputs)
	if (locale === "de") return de_pricing_feature_teams(inputs)
	if (locale === "ja") return ja_pricing_feature_teams(inputs)
	if (locale === "zh") return zh_pricing_feature_teams(inputs)
	if (locale === "ar") return ar_pricing_feature_teams(inputs)
	if (locale === "id") return id_pricing_feature_teams(inputs)
	if (locale === "it") return it_pricing_feature_teams(inputs)
	if (locale === "ru") return ru_pricing_feature_teams(inputs)
	if (locale === "pt") return pt_pricing_feature_teams(inputs)
	return ko_pricing_feature_teams(inputs)
});